/**
 * Router holder — a leaf module (imports nothing) that breaks the router ↔ store
 * import cycle. `@/router` registers the created instance here via `setRouter`, and
 * in-graph modules that cannot receive the router by DI (guards, `resolveRoute`
 * fallback, `envComponentDeletion`) read it lazily via `getRouter`.
 *
 * @typedef {import('vue-router').Router} Router
 */

/** @type {Router | null} */
let current = null

/** @param {Router} router */
export const setRouter = (router) => {
  current = router
}

/** @returns {Router | null} */
export const getRouter = () => current
